/** Parent policy prevents generated frames from navigating to a different origin.
 * CSP policies last for this document: a different development host needs reload.
 */
export function ensureHtml5FramePolicy(origin: string, doc: Document = document): boolean {
  try {
    const url = new URL(origin);
    if (
      url.origin !== origin ||
      !(url.protocol === "https:" || (url.protocol === "http:" && ["127.0.0.1", "[::1]"].includes(url.hostname)))
    )
      return false;
    const content = `frame-src ${origin}`;
    const installed = doc.head.querySelector("meta[data-interactads-html5-origin]");
    if (installed) return installed.getAttribute("content") === content;
    const meta = doc.createElement("meta");
    meta.httpEquiv = "Content-Security-Policy";
    meta.content = content;
    meta.setAttribute("data-interactads-html5-origin", origin);
    doc.head.append(meta);
    return true;
  } catch {
    return false;
  }
}
